import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import CommonTextField from "../../../../common/components/functional/commonTextField/CommonTextField";
import FormGridRow from "../../../../common/components/functional/formGridRow/FormGridRow";
import { Grid } from "@mui/material";
import { validateCustomerNumber } from "../../utils";

export const CreateCompanyForm = () => {
  const { t } = useTranslation(["customers", "common"]);

  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid container spacing={2} sx={{ margin: "8px" }}>
      <FormGridRow label={t("businessId")} labelSize={3} fieldSize={9}>
        <Controller
          control={control}
          name="businessId"
          rules={{ required: true }}
          render={({ field }) => (
            <CommonTextField
              {...field}
              sx={{ maxWidth: "372px" }}
              fullWidth
              error={!!errors.businessId}
              onChange={(e) => {
                const value = e.target.value.trim();
                field.onChange(value);
              }}
            />
          )}
        />
      </FormGridRow>
      <FormGridRow label={t("common:name")} labelSize={3} fieldSize={9}>
        <Controller
          control={control}
          name="name"
          rules={{ required: true }}
          render={({ field }) => (
            <CommonTextField
              {...field}
              sx={{ maxWidth: "372px" }}
              fullWidth
              error={!!errors.name}
            />
          )}
        />
      </FormGridRow>
      <FormGridRow label={t("customerNumber")} labelSize={3} fieldSize={9}>
        <Controller
          control={control}
          name="customerNumber"
          rules={{ required: true, validate: validateCustomerNumber }}
          render={({ field }) => (
            <CommonTextField
              {...field}
              sx={{ maxWidth: "372px" }}
              fullWidth
              error={!!errors.customerNumber}
              onChange={(e) => {
                const value = e.target.value.trim();
                field.onChange(value);
              }}
            />
          )}
        />
      </FormGridRow>
    </Grid>
  );
};
